/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
//import translation function for language translation
import { useTranslation } from "react-i18next";
/* Importing react select */
import Select from "react-select";
//import context
import { GlobalProvider } from "context/GlobalContext";
/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

const CostFilter = () => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const todayValue = new Date().toISOString().split("T")[0];

  const {
    setReloadCostList,
    setSearchCostDate,
    setSearchCostEducators,
    setSearchCostClients,
  } = useContext(GlobalProvider);

  const [selectedChecked, setSelectedChecked] = useState("");
  const [fromDate, setFromDate] = useState(todayValue);
  const [toDate, setToDate] = useState(todayValue);
  const [selectedDate, setSelectedDate] = useState(todayValue);
  const [clientList, setClientList] = useState([]);
  const [educatorList, setEducatorList] = useState([]);
  const [educatorValue, setEducatorValue] = useState(null);
  const [selectedEducators, setSelectedEducators] = useState([]);
  const [clientValue, setClientValue] = useState(null);
  const [selectedClients, setSelectedClients] = useState([]);
  const [dateWarning, setDateWarning] = useState(false);

  // Returns true when a value is considered "active" for tile highlighting
  const isSelected = (val) => (Array.isArray(val) ? val.length > 0 : !!val);
  const isDateSelected = () => selectedChecked !== "";

  const selectedTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({ ...base, backgroundColor: "transparent", borderColor: "transparent", boxShadow: "none" }),
  };

  const defaultTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  //function for select radio
  const radioCheckHandler = (event) => {
    setSelectedChecked(event.target.value);
    setDateWarning(false);
  };

  /* function to get all client list */
  const getALlClientList = async () => {
    try {
      let clientRequestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=client&limit=0`;
      let benificiaryRequestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=beneficiary&limit=0`;
      const clientResponse = await getData(clientRequestUrl);
      const beneficiaryResponse = await getData(benificiaryRequestUrl);
      if (clientResponse.status && beneficiaryResponse.status) {
        setClientList([...clientResponse.data, ...beneficiaryResponse.data]);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* function to get all educator list */
  const getALlEducatorList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=educator&limit=0`;
      const response = await getData(requestUrl);
      if (response.status) {
        setEducatorList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* function to select educators */
  const educatorsSelectionHandler = (val) => {
    setEducatorValue(val);
    setSelectedEducators(val.map((educator) => educator.value));
  };

  /* function to select client */
  const clientSelectionHandler = (val) => {
    setClientValue(val);
    setSelectedClients(val.map((client) => client.value));
  };

  //function for search
  const searchHandler = () => {
    switch (selectedChecked) {
      case "daterange":
        if (fromDate < toDate) {
          setSearchCostDate(fromDate + "," + toDate);
        } else {
          setDateWarning(true);
          return;
        }
        break;
      case "todayradio":
        setSearchCostDate(todayValue);
        break;
      case "salesdate":
        setSearchCostDate(selectedDate);
        break;
      default:
        setSearchCostDate("");
        break;
    }
    selectedClients.length > 0 && setSearchCostClients(selectedClients);
    selectedEducators.length > 0 && setSearchCostEducators(selectedEducators);
  };

  //function for reset
  const resetHandler = () => {
    setSelectedChecked("");
    setFromDate(todayValue);
    setToDate(todayValue);
    setSelectedDate(todayValue);
    setDateWarning(false);
    setClientValue(null);
    setSelectedClients([]);
    setEducatorValue(null);
    setSelectedEducators([]);
    setSearchCostDate("");
    setSearchCostEducators([]);
    setSearchCostClients([]);
    setReloadCostList(true);
  };

  useEffect(() => {
    getALlClientList();
    getALlEducatorList();
  }, []);

  return (
    <div className="collapse mt-3" id="filterCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1: Filter by Date ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>calendar_today</span>
              {t("Filter by Date")}
            </p>
            <div className="row g-3 align-items-start">

              {/* Date Range */}
              <div className="col-lg-5">
                <div className={`border rounded p-2 h-100 ${selectedChecked === "daterange" ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Date Range")}</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      className="form-check-input flex-shrink-0"
                      type="radio"
                      name="datefilter"
                      value="daterange"
                      checked={selectedChecked === "daterange"}
                      onChange={radioCheckHandler}
                    />
                    <div className="d-sm-flex border rounded flex-fill bg-white overflow-hidden">
                      <input
                        type="date"
                        className="form-control border-0 mb-2 mb-sm-0"
                        placeholder={t("From date")}
                        value={fromDate}
                        onChange={(e) => { setFromDate(e.target.value); setDateWarning(false); }}
                      />
                      <input
                        type="date"
                        className="form-control border-0 border-start"
                        placeholder={t("To date")}
                        value={toDate}
                        onChange={(e) => { setToDate(e.target.value); setDateWarning(false); }}
                      />
                    </div>
                  </div>
                  {dateWarning && (
                    <p className="d-flex align-items-center gap-1 text-danger small mt-1 mb-0">
                      <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
                      {t("End date should be greater than start date")}!
                    </p>
                  )}
                </div>
              </div>

              {/* Today */}
              <div className="col-lg-2">
                <div
                  className={`border rounded px-3 py-2 h-100 d-flex align-items-center gap-2 ${selectedChecked === "todayradio" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedChecked(selectedChecked === "todayradio" ? "" : "todayradio")}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="datefilter"
                    value="todayradio"
                    checked={selectedChecked === "todayradio"}
                    onChange={radioCheckHandler}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <label className="form-check-label small mb-0" style={{ cursor: "pointer" }}>
                    {t("Today")}
                  </label>
                </div>
              </div>

              {/* Specific Date */}
              <div className="col-lg-5">
                <div className={`border rounded p-2 h-100 ${selectedChecked === "salesdate" ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Specific Date")}</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      className="form-check-input flex-shrink-0"
                      type="radio"
                      name="datefilter"
                      value="salesdate"
                      checked={selectedChecked === "salesdate"}
                      onChange={radioCheckHandler}
                    />
                    <input
                      type="date"
                      className="form-control bg-white"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2: Filter by Person ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>person_search</span>
              {t("Filter by Person")}
            </p>
            <div className="row g-3">

              {/* Client */}
              <div className="col-lg-6">
                <div className={`border rounded p-2 h-100 ${isSelected(clientValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Client")}</label>
                  <Select
                    isMulti
                    options={clientList}
                    placeholder={t("Select clients")}
                    value={clientValue}
                    onChange={clientSelectionHandler}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(clientValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

              {/* Educator */}
              <div className="col-lg-6">
                <div className={`border rounded p-2 h-100 ${isSelected(educatorValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Educator")}</label>
                  <Select
                    isMulti
                    options={educatorList}
                    placeholder={t("Select educator")}
                    value={educatorValue}
                    onChange={educatorsSelectionHandler}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(educatorValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== Actions ===== */}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
            >
              <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
              {t("Filter")}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};
export default CostFilter;
